type FirebasePhoneAuthClient = typeof import('@/features/auth/firebasePhoneAuth');

let cachedClient: FirebasePhoneAuthClient | null = null;
let cachedClientPromise: Promise<FirebasePhoneAuthClient> | null = null;

export const loadFirebasePhoneAuthClient = async (): Promise<FirebasePhoneAuthClient> => {
    if (cachedClient) {
        return cachedClient;
    }

    cachedClientPromise ??= import('@/features/auth/firebasePhoneAuth')
        .then((client) => {
            cachedClient = client;
            return client;
        })
        .catch((error: unknown) => {
            cachedClientPromise = null;
            throw error;
        });

    return cachedClientPromise;
};

export const clearLoadedFirebasePhoneCode = () => {
    if (cachedClient) {
        cachedClient.clearFirebasePhoneCode();
        return;
    }

    if (cachedClientPromise) {
        void cachedClientPromise
            .then((client) => {
                client.clearFirebasePhoneCode();
            })
            .catch(() => undefined);
    }
};
